import InteractiveMap from './interactive-map';

export default class InteractiveMapDesktop extends InteractiveMap {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/interactive-map/interactive-map.desktop.js